import { render, staticRenderFns } from "./LegalDash.vue?vue&type=template&id=750b79db&scoped=true&"
import script from "./LegalDash.vue?vue&type=script&lang=js&"
export * from "./LegalDash.vue?vue&type=script&lang=js&"
import style0 from "./LegalDash.vue?vue&type=style&index=0&id=750b79db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b79db",
  null
  
)

export default component.exports